/**
 * 棋盘类
 * @param canvas Element or String html5 canvas tag or canvas id
 * @param options Object
 *		size Number board size, default 19
 */
function Board(canvas, options) {
	this.__canvas = canvas;
	this.__ctx = canvas.getContext("2d");
	this.boardArray = [];
	this.tags = [];
	this.estimate = [];
	this.lastOneStep = null

	this.boardImage = new Image();
	this.pieceImage = {
		black: new Image(),
		white: new Image()
	};

	this.size = options.size;
	this.canvasWidth = canvas.offsetWidth;
	this.boardImage.src = options.boardImage;
	this.pieceImage.black.src = options.black;
	this.pieceImage.white.src = options.white;


	this.style = {};
	this.style.padding = this.canvasWidth / (this.size + 2) + 5;

	if (options.sgf) {
		this.autoZoom(options.sgf)
	} else {
		this.top = 0
		this.left = 0
		this.right = this.size - 1
		this.bottom = this.size - 1
	}
	this.style.pieceWidth = (this.canvasWidth-this.style.padding*2) / (this.right - this.left)

	Promise.all([
		new Promise((resolve, reject) => {
			this.boardImage.onload = function () {
				resolve()
			}
		}),
		new Promise((resolve, reject) => {
			this.pieceImage.black.onload = function () {
				resolve()
			}
		}),
		new Promise((resolve, reject) => {
			this.pieceImage.white.onload = function () {
				resolve()
			}
		}),
	]).then(() => {
		this.redraw();
	})
}

/**
 * 自动缩放，设置pieceWidth，top，left 的值
 */
Board.prototype.autoZoom = function (sgf) {
	let arr = sgf.match(/\[[a-t]{2}\]/g).map(i => [
		i.charCodeAt(1)-'a'.charCodeAt(0),
		i.charCodeAt(2)-'a'.charCodeAt(0)
	])
	let a = arr.map(i => i[0])
	this.left = Math.min(...a) - 2
	this.right = Math.max(...a) + 2
	a = arr.map(i => i[1])
	this.top = Math.min(...a) - 2
	this.bottom = Math.max(...a) + 2

	let width=this.right-this.left;
	let height=this.bottom-this.top;
	width=Math.max(width, height);
	width = Math.min(width, this.size - 1)
	height=width;

	this.right=this.left+width;
	this.bottom=this.top+height;

	if (this.top < 0) {
		this.top = 0
		this.bottom = height
	}
	if (this.left < 0) {
		this.left = 0
		this.right = width
	}
	if (this.right > this.size - 1) {
		this.right = this.size - 1
		this.left = this.right - width
	}
	if (this.bottom > this.size - 1) {
		this.bottom = this.size - 1
		this.top = this.bottom - height
	}
}

/**
 * 重绘
 */
Board.prototype.redraw = function () {
	this.__ctx.clearRect(0, 0, this.__canvas.width, this.__canvas.height);
	this.drawBoard();
	this.drawPieces();
	this.drawTags();
	this.drawEstimate();
	this.drawLastStep();
	// this.drawRange();
}

/**
 * 输入点击位置，返回棋盘坐标
 */
Board.prototype.coordinate = function (x, y) {
	let p = this.iToF({x:-0.5,y:-0.5})
	let o = {
		x: Math.floor((x - p.x) / this.style.pieceWidth),
		y: Math.floor((y - p.y) / this.style.pieceWidth)
	}
	return o
}

Board.prototype.iToF = function ({x, y}) {
	let o = {
		x: this.intXToFloatX(x),
		y: this.intYToFloatY(y)
	};
	return o
}




let star = {
	9: [{x:2, y:2}, {x:6,y:2},{x:2,y:6},{x:6,y:6},{x:4,y:4}],
    10: [],
	13:[
		{x:3,y:3},{x:3,y:6},{x:3,y:9},
		{x:6,y:3},{x:6,y:6},{x:6,y:9},
		{x:9,y:3},{x:9,y:6},{x:9,y:9}
	],
	19: [
		{x:3,y:3},{x:3,y:9},{x:3,y:15},
		{x:9,y:3},{x:9,y:9},{x:9,y:15},
		{x:15,y:3},{x:15,y:9},{x:15,y:15}
	],
}
/**
 * 根据棋盘坐标，计算canvas坐标
 */
Board.prototype.intXToFloatX = function (x) {
	return this.style.padding + this.style.pieceWidth * (x-this.left)
}
Board.prototype.intYToFloatY = function (y) {
	//  this.style.padding + this.style.pieceWidth * (i -this.top)
	return this.style.padding + this.style.pieceWidth * (y-this.top)
}
 /**
 * 画棋盘
 */
Board.prototype.drawBoard = function () {
	this.__ctx.drawImage(this.boardImage, 0, 0, this.canvasWidth, this.canvasWidth);
	this.__ctx.lineWidth = 2
	this.__ctx.strokeStyle = "#000000"

	this.__ctx.beginPath()
	for (var i = 0; i < this.size; i++) {
		// 画棋盘线，去掉边
		if (i != this.left && i != this.right) {
			this.__ctx.moveTo(this.intXToFloatX(i), this.intYToFloatY(this.top));
			this.__ctx.lineTo(this.intXToFloatX(i), this.intYToFloatY(this.bottom));
			// console.log(this.intXToFloatX(i), this.intYToFloatY(this.top), this.intXToFloatX(i), this.intYToFloatY(this.bottom));
		}
		if (i != this.top && i != this.bottom) {
			this.__ctx.moveTo(this.intXToFloatX(this.left), this.intYToFloatY(i));
			this.__ctx.lineTo(this.intXToFloatX(this.right), this.intYToFloatY(i));
		}
	}

	// 画棋盘边
	this.__ctx.moveTo(this.intXToFloatX(0), this.intYToFloatY(this.top));
	this.__ctx.lineTo(this.intXToFloatX(0), this.intYToFloatY(this.bottom));
	this.__ctx.moveTo(this.intXToFloatX(this.size - 1), this.intYToFloatY(this.top));
	this.__ctx.lineTo(this.intXToFloatX(this.size - 1), this.intYToFloatY(this.bottom));

	this.__ctx.moveTo(this.intXToFloatX(this.left), this.intYToFloatY(0));
	this.__ctx.lineTo(this.intXToFloatX(this.right), this.intYToFloatY(0));
	this.__ctx.moveTo(this.intXToFloatX(this.left), this.intYToFloatY(this.size - 1));
	this.__ctx.lineTo(this.intXToFloatX(this.right), this.intYToFloatY(this.size - 1));

	this.__ctx.stroke();
	for (var i = 0; i < star[this.size].length; i++) {
		let {x, y} = this.iToF(star[this.size][i]);
		this.__ctx.beginPath();
		this.__ctx.fillStyle = "black"
		this.__ctx.arc(x, y, this.style.pieceWidth/7, 0, Math.PI * 2);
		this.__ctx.fill();
	}
}

/**
 * 画棋子
 */
Board.prototype.drawPieces = function () {
	let p = this.style.padding - this.style.pieceWidth / 2;
	for (var w = 0; w < this.boardArray.length; w++) {
		for (var h = 0; h < this.boardArray[w].length; h++) {
			if (this.boardArray[w][h] == 1) {
				this.__ctx.drawImage(
					this.pieceImage.black,
					this.intXToFloatX(w - 0.5),
					this.intYToFloatY(h - 0.5),
					this.style.pieceWidth,
					this.style.pieceWidth
				)
			} else if (this.boardArray[w][h] == -1) {
				this.__ctx.drawImage(
					this.pieceImage.white,
					this.intXToFloatX(w - 0.5),
					this.intYToFloatY(h - 0.5),
					this.style.pieceWidth,
					this.style.pieceWidth
				)
			}
		}
	}

}
/**
 * 画形势判断范围
 */
 Board.prototype.drawEstimate = function () {
	let p = this.style.padding - this.style.pieceWidth / 2;

	for (var w = 0; w < this.estimate.length; w++) {
		for (var h = 0; h < this.estimate[w].length; h++) {
			if (this.estimate[w][h] == 1) {
				this.__ctx.drawImage(
					this.pieceImage.black,
					this.intXToFloatX(w - 0.25),
					this.intYToFloatY(h - 0.25),
					this.style.pieceWidth / 2,
					this.style.pieceWidth / 2
				)
			} else if (this.estimate[w][h] == -1) {
				this.__ctx.drawImage(
					this.pieceImage.white,
					this.intXToFloatX(w - 0.25),
					this.intYToFloatY(h - 0.25),
					this.style.pieceWidth / 2,
					this.style.pieceWidth / 2
				)
			}
		}
	}
 }

/**
 * 画标记
 */
Board.prototype.drawTags = function () {
	let p = this.style.padding - this.style.pieceWidth / 2
	this.__ctx.font = font[this.size].s + "px bold"
	for (var w = 0; w < this.tags.length; w++) {
		for (var h = 0; h < this.tags[w].length; h++) {
			if (this.tags[w][h] !== 0) {
				let b = this.boardArray[w][h] == 0 ? 4 : 1
				let c = this.boardArray[w][h] == 0 ? "#d2eaca" : "rgba(0,0,0,0.2)"
				for (var i = -b; i<=b; i++) {
					this.__ctx.fillStyle = c
					for (var j = -b; j <= b; j++) {
						this.__ctx.fillText(
							this.tags[w][h],
							font[this.size].x + this.style.pieceWidth * w + i,
							font[this.size].y + this.style.pieceWidth * h + j
						)
					}
				}
				this.__ctx.fillStyle = "#d1071f"
				this.__ctx.fillText(
					this.tags[w][h],
					font[this.size].x + this.style.pieceWidth * w,
					font[this.size].y + this.style.pieceWidth * h
				)
			}
		}
	}
}
let font = {
	"9": {
		x: 57,
		y: 90,
		s: 48
	},
    "10": {
        x: 57,
        y: 90,
        s: 48
    },
	"13": {
		x: 57,
		y: 90,
		s: 48
	},
	"19": {
		x: 31,
		y: 52,
		s: 28
	}
}

function getTop(board) {
	for (var i = 0; i < board.length; i++) {
		for (var j = 0; j < board[i].length; j++) {
			if (board[j][i] != 0) {
				return i
			}
		}
	}
}
function getLeft(board) {
	for (var i = 0; i < board.length; i++) {
		for (var j = 0; j < board[i].length; j++) {
			if (board[i][j] != 0) {
				return i
			}
		}
	}
}
function getRight(board) {
	for (var i = board.length - 1; i >= 0; i--) {
		for (var j = board[i].length - 1; j >= 0; j--) {
			if (board[i][j] != 0) {
				return i
			}
		}
	}
}
function getBottom(board) {
	for (var i = board.length - 1; i >= 0; i--) {
		for (var j = board[i].length - 1; j >= 0; j--) {
			if (board[j][i] != 0) {
				return i
			}
		}
	}
}
Board.prototype.drawRange = function () {

	if (top) {
		let {x, y} = this.iToF({x:this.left, y:this.top})
		x -= this.style.pieceWidth / 2
		y -= this.style.pieceWidth / 2
		let w = (this.right - this.left + 1) * this.style.pieceWidth
		let h = (this.bottom - this.top + 1) * this.style.pieceWidth
		this.__ctx.beginPath()
		this.__ctx.strokeStyle = "red"
		this.__ctx.lineWidth = 10
		this.__ctx.strokeRect(x - 5, y - 5, w + 10, h + 10)
	}

}



/**
 * 画最后一步的标记
 */
Board.prototype.drawLastStep = function () {
	if (this.lastOneStep) {
		let x = this.intXToFloatX(this.lastOneStep.tagValue.charCodeAt(0) - "a".charCodeAt(0))
		let y = this.intYToFloatY(this.lastOneStep.tagValue.charCodeAt(1) - "a".charCodeAt(0))
		let r = this.style.pieceWidth / 5
		this.__ctx.beginPath()

		this.__ctx.fillStyle = this.lastOneStep.tag == "B" ? "white" : "black"
		this.__ctx.arc(x, y, r, 0, 2 * Math.PI)
		this.__ctx.fill()
	}
}


export default Board;



// WEBPACK FOOTER //
// ./components/go/board.js